import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

const SESSION_KEY = "roofgenius_platform_session_id";

const getSessionId = () => {
  const existing = sessionStorage.getItem(SESSION_KEY);
  if (existing) return existing;
  const next = crypto.randomUUID();
  sessionStorage.setItem(SESSION_KEY, next);
  return next;
};

export function usePlatformPageTracking() {
  const location = useLocation();
  const { user, orgId } = useAuth();

  useEffect(() => {
    if (!user) return;

    const path = `${location.pathname}${location.search}`;
    void (supabase as any).from("platform_page_events").insert({
      user_id: user.id,
      org_id: orgId,
      path,
      title: document.title,
      referrer: document.referrer || null,
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
      metadata: { hash: location.hash || null },
    });
  }, [location.pathname, location.search, location.hash, orgId, user]);
}